(ns manage.resource.content-optimizing
  (:require [common.url-template :as url-tpl]
            [common.util :as util]
            [re-frame.core :as rf]))

(rf/reg-event-fx :resource.content-optimizing/post-optimization
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context] :as cofx} [_ {:keys [params on-success on-failure]}]]
    {:fx [[:http
           {:method :post
            :uri (url-tpl/render :api/adset-optimizations url-context)
            :headers {"Authorization" (:resource.user/token cofx)}
            :params params
            :on-success on-success
            :on-failure on-failure}]]}))

(rf/reg-event-fx :resource.content-optimizing/patch-optimization
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context] :as cofx} [_ {:keys [params on-success on-failure]}]]
    {:fx [[:http
           {:method :patch
            :uri (url-tpl/render :api/adset-optimization (assoc url-context :optimization-id (:id params)))
            :headers {"Authorization" (:resource.user/token cofx)}
            :params (dissoc params :id)
            :on-success on-success
            :on-failure on-failure}]]}))

(rf/reg-event-fx :resource.content-optimizing/get-optimizations
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx}]
    {:db (assoc db :resource.content-optimizing/optimizations {:state :pending})
     :fx [[:http
           {:method :get
            :uri (url-tpl/render :api/adset-optimizations url-context)
            :headers {"Authorization" (:resource.user/token cofx)}
            :on-success [:resource.content-optimizing/get-optimizations-success]
            :on-failure [:resource.content-optimizing/get-optimizations-failure]}]]}))

(rf/reg-event-db :resource.content-optimizing/get-optimizations-success
  (fn [db [_ optimizations]]
    (assoc db :resource.content-optimizing/optimizations
           {:state :success :value (util/index-by :test-name optimizations)})))

(rf/reg-event-db :resource.content-optimizing/get-optimizations-failure
  (fn [db [_ _]]
    (assoc db :resource.content-optimizing/optimizations
           {:state :failure :value nil})))

(rf/reg-sub :resource.content-optimizing/optimizations
  ;; an optional name can be provided to get an optimization for a specific key name
  (fn [db [_ key-name]]
    (get-in db (cond-> [:resource.content-optimizing/optimizations :value]
                 key-name (conj key-name)))))

(rf/reg-event-fx :resource.content-optimizing/get-algorithms
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx}]
    {:db (assoc db :resource.content-optimizing/algorithms {:state :pending :value nil})
     :fx [[:http
           {:method :get
            :uri (url-tpl/render :measure-api/content-optimizing-algorithms url-context)
            :headers {"Authorization" (:resource.user/token cofx)}
            :on-success [:resource.content-optimizing/get-algorithms-success]
            :on-failure [:resource.content-optimizing/get-algorithms-failure]}]]}))

(rf/reg-event-db :resource.content-optimizing/get-algorithms-success
  (fn [db [_ algorithms]]
    (assoc db :resource.content-optimizing/algorithms {:state :success :value algorithms})))

(rf/reg-event-db :resource.content-optimizing/get-algorithms-failure
  (fn [db [_ _]]
    (assoc db :resource.content-optimizing/algorithms {:state :failure})))

(rf/reg-sub :resource.content-optimizing/algorithms
  (fn [db _]
    (:resource.content-optimizing/algorithms db)))
